import { FormStep } from "@components/PatientForms/FormContext/types";
import { providerHistoryValidation, providerHistorySchema } from "@components/PatientForms/categories/ProviderHistory";
import { medicationsValidation, medicationsSchema, handleRemoveMedications } from "@components/PatientForms/categories/Medications";
import { pastMedicalHistoryValidation, pastMedicalHistorySchema } from "@components/PatientForms/categories/PastMedicalHistory";
import { socialHistoryValidation, socialHistorySchema } from "@components/PatientForms/categories/SocialHistory";
import { familyHistoryValidation, familyHistorySchema } from "@components/PatientForms/categories/FamilyHistory";
import {
  sleepMedicineHistoryValidation,
  sleepMedicineHistorySchema,
  sleepQuestionnaireSchema,
	epworthSleepinessScaleSchema,
	sleepStudyFileUpload,
	setEpworthToNull,
	calculateEpworthScore
} from "@components/PatientForms/categories/SleepMedicineHistory";
import { 
  reviewOfSystemsValidation,
  currentHealthSchema,
  accidentRelatedSchema
} from "@components/PatientForms/categories/ReviewOfSystems";
import { weightHealthSchema, weightHealthValidation } from "@components/PatientForms/categories/WeightHealth";

export const steps: FormStep[] = [
	{
		id: "provider-history",
		title: "Provider History",
		category: "providerHistory",
		schema: providerHistorySchema,
		validation: providerHistoryValidation,
	},
	{
		id: "medications",
		title: "Medications",
		abbreviation: "Meds",
		category: "medications",
		schema: medicationsSchema,
		validation: medicationsValidation,
		handleSubmit: handleRemoveMedications,
	},
	{
		id: "past-medical-history",
		title: "Past Medical History",
		category: "pastMedicalHistory",
		schema: pastMedicalHistorySchema,
		validation: pastMedicalHistoryValidation,
	},
	{
		id: "social-history",
		title: "Social History",
		category: "socialHistory",
		schema: socialHistorySchema,
		validation: socialHistoryValidation,
	},
	{
		id: "family-history",
		title: "Family History",
		category: "familyHistory",
		schema: familyHistorySchema,
		validation: familyHistoryValidation,
	},
	{
		id: "sleep-medicine-history",
		title: "Sleep Medicine History",
		category: "sleepMedicineHistory",
		schema: sleepMedicineHistorySchema,
		validation: sleepMedicineHistoryValidation,
		handleSubmit: sleepStudyFileUpload
	},
	{
		id: "sleep-questionnaire",
		title: "Sleep Habits",
		category: "sleepMedicineHistory",
		schema: sleepQuestionnaireSchema,
		validation: sleepMedicineHistoryValidation,
	},
	{
		id: "epworth-sleepiness-scale",
		title: "Sleep Assessment",
		abbreviation: "Sleep Assmt.",
		category: "sleepMedicineHistory",
		schema: epworthSleepinessScaleSchema,
		validation: sleepMedicineHistoryValidation,
		onLoadData: setEpworthToNull,
		handleSubmit: calculateEpworthScore
	},
	{
		id: "weight-health",
		title: "Weight Health",
		category: "weightHealth",
		schema: weightHealthSchema,
		validation: weightHealthValidation,
	},
	{
		id: "current-health",
		title: "Current Health",
		category: "reviewOfSystems",
		schema: currentHealthSchema,
		validation: reviewOfSystemsValidation,
	},
	{
		id: "accident-related",
		title: "Accidents",
		category: "reviewOfSystems",
		schema: accidentRelatedSchema,
		validation: reviewOfSystemsValidation,
	}
];